const DEFAULT_ENDPOINT = "/api/mail.php";
const SUBMIT_TIMEOUT_MS = 45000;

function resolveEndpoint() {
  if (process.env.REACT_APP_FORM_ENDPOINT) {
    return process.env.REACT_APP_FORM_ENDPOINT;
  }

  return DEFAULT_ENDPOINT;
}

const FILE_FIELD_NAMES = new Set(["attachment", "resume"]);

function buildFormData(formType, data) {
  const formData = new FormData();
  formData.append("formType", formType);
  formData.append("submittedAt", new Date().toISOString());
  formData.append("source", window.location.pathname);

  Object.entries(data).forEach(([key, value]) => {
    if (value == null || value === "") {
      return;
    }

    if (value instanceof File) {
      formData.append(key, value, value.name);
      return;
    }

    if (FILE_FIELD_NAMES.has(key)) {
      return;
    }

    formData.append(key, String(value));
  });

  return formData;
}

function buildNetworkError(error) {
  if (error?.name === "AbortError") {
    return new Error(
      "The submission timed out. Please check your connection and try again.",
    );
  }

  if (
    error instanceof TypeError &&
    /failed to fetch|networkerror|load failed/i.test(error.message)
  ) {
    if (process.env.NODE_ENV === "development") {
      return new Error(
        "Could not reach the form API. Restart with npm start so both the website and mail server run together.",
      );
    }

    return new Error(
      "Could not connect to the server. Please try again in a moment or email career@southasiaconsultancy.com directly.",
    );
  }

  return error instanceof Error
    ? error
    : new Error("Form submission failed. Please try again.");
}

export async function submitInquiry(formType, data) {
  const endpoint = resolveEndpoint();
  const controller = new AbortController();
  const timeoutId = window.setTimeout(
    () => controller.abort(),
    SUBMIT_TIMEOUT_MS,
  );

  let response;

  try {
    response = await fetch(endpoint, {
      method: "POST",
      body: buildFormData(formType, data),
      signal: controller.signal,
    });
  } catch (error) {
    throw buildNetworkError(error);
  } finally {
    window.clearTimeout(timeoutId);
  }

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (
    !response.ok ||
    payload.success === false ||
    payload.ok === false
  ) {
    throw new Error(
      payload.message ||
        payload.error ||
        (response.status === 503
          ? "Email service is temporarily unavailable. Please try again later or contact us directly."
          : "Form submission failed"),
    );
  }

  if (payload.success !== true && payload.ok !== true) {
    throw new Error(
      payload.message ||
        payload.error ||
        "Form submission failed. Please try again.",
    );
  }

  return {
    method: "api",
    recipient: payload.recipient,
    messageId: payload.messageId,
  };
}
